import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function requestOTP(token,params){

    try {
        return await Api.post(REQUEST_URLS.ESTATE.REQUEST_OTP,params,{
            headers:{
                "Authorization": `Bearer ${token}`
            }
        });
    }
    catch (e){

    }

}
export default requestOTP;